import React from 'react';
import { useParams } from 'react-router-dom';
import AuthService from 'services/AuthService';
import EPDCertificatePage from 'pages/v2/compiler/PDF/EPDRegistrationCertificatePage';
import { useDocumentRegistrationCertificateData } from 'services/api/queries';

// Renders the shared certificate page against Dynamic Forms data; the layout itself is unchanged.
const DynamicFormRegistrationCertificatePreviewAuth: React.FunctionComponent = () => {
  const { id } = useParams<any>();
  const certificateData = useDocumentRegistrationCertificateData(id).data;

  if (!AuthService.isLoggedin()) {
    return null;
  }

  if (!certificateData) {
    return <div>Loading data...</div>;
  }

  return <EPDCertificatePage epdCertificateData={certificateData} />;
};

export default DynamicFormRegistrationCertificatePreviewAuth;
